class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    //console.log(this.querySelector('form'));
    if (typeof this.querySelector("form") != null) {
      this.querySelector("form").addEventListener(
        "input",
        this.debouncedOnSubmit.bind(this)
      );
    }

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");

    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    var endlessScroll = new Ajaxinate({
      container: ".Huratips-Loop",
      pagination: "#Huratips-Pagination",
      loadingText:
        'Loading <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path></svg>',
      callback: function () {
        var swiper = new Swiper(".list_product-colors", {
          slidesPerView: 4,
          cssMode: true,
          slidesPerGroup: 4,
          loopedSlides: 4,
          spaceBetween: 0,
          navigation: {
            nextEl: ".icon-next",
          },
          breakpoints: {
            768: {
              slidesPerView: 5,
              spaceBetween: 0,
              slidesPerGroup: 5,
              loopedSlides: 5,
            },
          },
        });

        $(".swiper-wrapper").each(function (index) {
          $(this).on("scroll", chk_scroll);
        });

        function chk_scroll(e) {
          var elem = $(e.currentTarget);

          if (
            elem[0].scrollWidth - elem.scrollLeft() <=
            elem.outerWidth() + 3
          ) {
            $(this).parent().find(".icon-prev").css("display", "block");
            $(this).parent().find(".icon-next").css("display", "none");
          } else {
            $(this).parent().find(".icon-prev").css("display", "none");
            $(this).parent().find(".icon-next").css("display", "block");
          }
        }
        $(".icon-prev").click(function () {
          let index = $(".icon-prev").index(this);

          setTimeout(function () {
            swiper[index].slideTo(1);
          }, 175);
        });
      },
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);

    setTimeout(function () {
      var swiper = new Swiper(".list_product-colors", {
        slidesPerView: 4,
        cssMode: true,
        slidesPerGroup: 4,
        loopedSlides: 4,
        navigation: {
          nextEl: ".icon-next",
          breakpoints: {
            1920: {
              slidesPerView: 4,
            },
            1028: {
              slidesPerView: 4,
            },
            480: {
              slidesPerView: 4,
            },
          },
        },
      });
      $(document).ready(function () {
        $(".swiper-wrapper").each(function (index) {
          $(this).on("scroll", chk_scroll);
        });
      });

      function chk_scroll(e) {
        var elem = $(e.currentTarget);

        if (elem[0].scrollWidth - elem.scrollLeft() <= elem.outerWidth() + 3) {
          $(this).parent().find(".icon-prev").css("display", "block");
          $(this).parent().find(".icon-next").css("display", "none");
        } else {
          $(this).parent().find(".icon-prev").css("display", "none");
          $(this).parent().find(".icon-next").css("display", "block");
        }
      }

      $(".icon-prev").click(function () {
        let index = $(".icon-prev").index(this);

        setTimeout(function () {
          swiper[index].slideTo(1);
        }, 175);
      });

      $(document).ready(function () {
        // $( ".color-option:not(.customization_color)" ).mouseover(function() {
        //     $(this).each(function(){
        //       $(this).parents('.list_product-colors').find('.color-option').removeClass('active');
        //       $(this).addClass('active');
        //     });
        //   });
      });
    }, 3000);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    var swiper = new Swiper(".list_product-colors", {
      slidesPerView: 4,
      cssMode: true,
      slidesPerGroup: 4,
      loopedSlides: 4,
      navigation: {
        nextEl: ".icon-next",
      },
    });
    $(document).ready(function () {
      $(".swiper-wrapper").each(function (index) {
        $(this).on("scroll", chk_scroll);
      });
    });
    second_image_alt;

    function chk_scroll(e) {
      var elem = $(e.currentTarget);

      if (elem[0].scrollWidth - elem.scrollLeft() <= elem.outerWidth() + 3) {
        $(this).parent().find(".icon-prev").css("display", "block");
        $(this).parent().find(".icon-next").css("display", "none");
      } else {
        $(this).parent().find(".icon-prev").css("display", "none");
        $(this).parent().find(".icon-next").css("display", "block");
      }
    }

    $(".icon-prev").click(function () {
      let index = $(".icon-prev").index(this);
      setTimeout(function () {
        swiper[index].slideTo(1);
      }, 175);
    });

    $(document).ready(function () {
      $(".color-option:not(.customization_color)").mouseover(function () {
        $(this).each(function () {
          $(this)
            .parents(".list_product-colors")
            .find(".color-option")
            .removeClass("active");
          $(this).addClass("active");
        });
      });
    });
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
      setTimeout(function () {
        var swiper = new Swiper(".list_product-colors", {
          slidesPerView: 5,
          cssMode: true,
          slidesPerGroup: 5,
          loopedSlides: 5,
          navigation: {
            nextEl: ".icon-next",
          },
        });
        $(document).ready(function () {
          $(".swiper-wrapper").each(function (index) {
            $(this).on("scroll", chk_scroll);
          });
        });

        function chk_scroll(e) {
          var elem = $(e.currentTarget);

          if (
            elem[0].scrollWidth - elem.scrollLeft() <=
            elem.outerWidth() + 3
          ) {
            $(this).parent().find(".icon-prev").css("display", "block");
            $(this).parent().find(".icon-next").css("display", "none");
          } else {
            $(this).parent().find(".icon-prev").css("display", "none");
            $(this).parent().find(".icon-next").css("display", "block");
          }
        }
        $(".icon-prev").click(function () {
          let index = $(".icon-prev").index(this);

          setTimeout(function () {
            swiper[index].slideTo(1);
          }, 175);
        });

        $(".color-option:not(.customization_color)").mouseover(function () {
          $(this).each(function () {
            $(this)
              .parents(".list_product-colors")
              .find(".color-option")
              .removeClass("active");
            $(this).addClass("active");
          });
        });
      }, 1500);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

// function hoverEvent(event){
//   colorClicked = event.target.className;
//   vid  = event.target.id;
//   vurl = event.target.getAttribute('v-url');
//   $('img[img-id="'+vid+'"]').addClass('hide');
//   $('img[img-id="'+vid+'"][img-text~="'+colorClicked+'"]').removeClass('hide');
//   $('.card-wrapper[p-id="'+vid+ '"] .card-information__wrapper .card-information__text a').attr('href',vurl); $('.card-wrapper[p-id="'+vid+ '"] .card-information__wrapper .card-information__text a').attr('href',vurl);

//   console.log(colorClicked,vid,vurl);
// }
// $(document).on("mouseenter",".color-option span",function(e){
// $(this).parents('.card-wrapper').find('.newbadge_discount').addClass('hide');
// // var wishlistid = $(this).attr('data-wishvarid');
// // console.log(wishlistid);
// // $('body').find('.wk-button--floating').attr('data-wk-remove-product', wishlistid);
//   // var idvariant = $(this).attr('data-variantid');
//   // var origin=window.location.origin;
//   // var pathname=window.location.pathname;
//   // window.history.pushState({}, '', origin+pathname+'?variant='+idvariant);
//   var click_color = $(this).attr("data-color");
//   let discountbadge = $(this).attr('data-value');
// $(this).parents('.card-wrapper').find('.newbadge_discount[data-colormatch="'+discountbadge+'"]').removeClass('hide');
//     // $('.newbadge_discount').each(function(){
//     // let newbadge = $(this).attr('data-colormatch');
//     //   if(newbadge == discountbadge){
//     //      //$(this).parents('.card-wrapper').find('.newbadge_discount[data-colormatch="'+discountbadge+'"]').removeClass('hide');

//     //   }
//     // });
//     // $('.newbadge_discount').addClass('hide');
//     // var checktag =$(this).attr('data-tagavailability');
//     // if(checktag == "true" || checktag == true){
//     // $(this).find('.custtomtag1').addClass('shoasasw');
//     // }
//     // else{
//     // $(this).find('.custtomtag1').removeClass('shoasasw');
//     // }
//       var p_price = $(this).attr('data-price');
//       var p_compare_price = $(this).attr('data-compareprice');
//       var p_badges = $(this).attr('data-badges');
//       var swatchclr = $(this).attr('data-color');
//       if(swatchclr == "Graphite Grey"){
//       $(this).parents('.card-wrapper').find('.customdiscounttags').addClass("hidediscount");
//       }
//       else{
//       $(this).parents('.card-wrapper').find('.customdiscounttags').removeClass("hidediscount");
//       }
//      if(typeof(p_compare_price) != 'undefined' && p_compare_price != '')
//      {
//        $(this).parents('.card-wrapper').find(".price:not(.cust_make_it_price) .without_sale_price").text(p_compare_price);
//        $(this).parents('.card-wrapper').find(".price:not(.cust_make_it_price) .price-item--sale").text(p_price);
//        $(this).parents('.card-wrapper').find(".newpricecustomgs").show();
//        $(this).parents('.card-wrapper').find(".without_s_price").hide();
//        $(this).parents('.card-wrapper').find(".with_s_price").show();
//      }
//      else {
//        //$(this).parents('.card-wrapper').find(".without_sale_price").show();
//        $(this).parents('.card-wrapper').find(".newpricecustomgs").hide();
//        $(this).parents('.card-wrapper').find(".price:not(.cust_make_it_price) .price-item--regular").text(p_price);
//        // $(this).parents('.card-wrapper').find(".price:not(.cust_make_it_price) .price-item--sale").text('');
//        $(this).parents('.card-wrapper').find(".without_s_price").show();
//        $(this).parents('.card-wrapper').find(".with_s_price").hide();
//      }
//     let colorClicked  = $(this).attr('class');
//     let dataPersonlise  = $(this).attr('data-personalize');
//     let vid  = $(this).attr('id');
//     let vurl = $(this).attr('v-url');
//     var colorofyear = $(this).attr('data-color');
//     var color_of_year_main = $("#color_of_year_main").val();
//     if( colorofyear == color_of_year_main){
//     $(this).parents('.card-wrapper').find('.colorofyear').removeClass('hide');
//     }
//     else{
//     $(this).parents('.card-wrapper').find('.colorofyear').addClass('hide');
//     }
//   // check new custom tags
//      var checkcusattr1 = $(this).attr('data-tag1');
//      var checkcusattrvalue1 = $(this).attr('data-tagvalue1');
//      var checkcusattr2 = $(this).attr('data-tag2');
//      var checkcusattrvalue2 = $(this).attr('data-tagvalue2');
//      var checkcusattr3 = $(this).attr('data-tag3');
//      var checkcusattrvalue3 = $(this).attr('data-tagvalue3');

//      if(checkcusattr1 == 'true' || checkcusattr1 == true)
//      {
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag1').removeClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag1').text(checkcusattrvalue1);
//      }else{
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag1').addClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag1').text('');
//      }
//      if(checkcusattr2 == 'true' || checkcusattr2 == true)
//      {
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag2').removeClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag2').text(checkcusattrvalue2);
//      }else{
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag2').addClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag2').text('');
//      }
//      if(checkcusattr3 == 'true' || checkcusattr3 == true)
//      {
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag3').removeClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag3').text(checkcusattrvalue3);
//      }else{
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag3').addClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag3').text('');
//      }

//   // ends
//     var url = $('.card--product a').attr('href')
//     $(this).parents('.card-wrapper').find('.card-information__wrapper a').attr('href',vurl);
//     $(this).parents('.card-wrapper').find('.card--product a').attr('href',vurl);

//     if(dataPersonlise == "true" || dataPersonlise == true)
//     {
//       $(this).parents('.card-wrapper').find('.engrave').addClass('nomonogramshows');
//     }
//     else
//     {
//       $(this).parents('.card-wrapper').find('.engrave').removeClass('nomonogramshows');
//     }
//     $('img[img-id="'+vid+'"]').addClass('hide');
//     $('img[img-id="'+vid+'"][img-text~="'+colorClicked+'"]').removeClass('hide');
//     $('.image-2-flip .product_image_list_2').addClass('hide');
//     $('.image-2-flip .product_image_list_2[data-alt="'+colorClicked+' flip"]').removeClass('hide');

// });
$(document).ready(function () {
  $(".color-option:not(.customization_color)").mouseover(function () {
    $(this).each(function () {
      $(this)
        .parents(".list_product-colors")
        .find(".color-option")
        .removeClass("active");
      $(this).addClass("active");
    });
  });
});
$(document).ready(function () {
  $(".color-option.customization_color").click(function () {
    $(this).each(function () {
      $(this)
        .parents(".list_product-colors")
        .find(".color-option")
        .removeClass("active");
      $(this).addClass("active");
    });
  });
});

$(document).ready(function () {
  $(".apple_watch_product .product-sizes-watch").change(function () {
    var size_select_watch = $(this).val();
    var option_input_radio = $(".option_input[name='Color']:checked").val();

    var full_var = size_select_watch + " / " + option_input_radio;
    var splitval = "";
    var selectdro = "";
    // $(".newbadge_discount").addClass('hide');
    $(".product-form__input input:checked").each(function (key) {
      if (key == 0) {
        selectdro = $(this).val();
      } else {
        selectdro = size_select_watch + " / " + $(this).val();
        splitval = size_select_watch + "&" + $(this).val();
      }
    });
    var splitchar = splitval.split("&");
    var checkatt1 = splitchar[0];
    var checkatt2 = splitchar[1];
    let allSpam = document.querySelectorAll(
      ".product-tag-list .newbadge_discount"
    );
    allSpam.forEach((ele) => {
      if (
        checkatt1 == ele.getAttribute("data-option1") &&
        checkatt2 == ele.getAttribute("data-option2")
      ) {
        ele.classList.remove("hide");
      } else {
        if (!ele.classList.contains("hide")) {
          ele.classList.add("hide");
        }
      }
    });
    $(".ctm_product_form_variants option").each(function () {
      var p_price = $(this).attr("data-price");
      var p_compare_price = $(this).attr("data-compareprice");
      if ($(this).text().trim() == full_var) {
        if (typeof p_compare_price != "undefined" && p_compare_price != "") {
          $(".price:not(.cust_make_it_price) .price-item--regular").text(
            p_compare_price
          );
          $(".price:not(.cust_make_it_price) .price-item--sale").text(p_price);
          $(".newpricecustomgs").show();
          $(".without_sale_price").hide();
        } else {
          $(".newpricecustomgs").hide();
          $(".without_sale_price").show();
          $(".price:not(.cust_make_it_price) .price-item--regular").text(
            p_price
          );
          $(".price__badge-sale").hide();
        }
        var checkavailable = $(this).attr("data-avalilability");
        if (checkavailable == "true" || checkavailable == true) {
          // $('.color-swatch[data-value='+dd_val+']').removeAttr("data-stock-status", "out_of_stock");
        } else {
          $(".color-swatch[data-value=" + dd_val + "]").attr(
            "data-stock-status",
            "out_of_stock"
          );
        }
      }
    });
    $(".apple_watch_product .color-swatch").click(function () {
      // $(".newbadge_discount").addClass('hide');
      var select_size_app_wat = $(".product-sizes-watch").val();
      var selectdro2 = select_size_app_wat + "&" + $(this).attr("data-color");
      var splitchar = selectdro2.split("&");
      var splittag1 = splitchar[0];
      var splittag2 = splitchar[1];
      // $(".newbadge_discount[data-colormatch='"+splittag1+"'][data-colormatch1='"+splittag2+"']").removeClass('hide');
      if (
        select_size_app_wat != "" ||
        typeof select_size_app_wat != "undefined"
      ) {
        var selectdro =
          select_size_app_wat + " / " + $(this).attr("data-color");
        let allSpam = document.querySelectorAll(
          ".product-tag-list .newbadge_discount"
        );
        allSpam.forEach((ele) => {
          if (
            select_size_app_wat == ele.getAttribute("data-option1") &&
            $(this).attr("data-color") == ele.getAttribute("data-option2")
          ) {
            ele.classList.remove("hide");
          } else {
            if (!ele.classList.contains("hide")) {
              ele.classList.add("hide");
            }
          }
        });

        $(".ctm_product_form_variants option").each(function () {
          if ($(this).text().trim() == selectdro) {
            var fetchid = $(this).attr("data-idvalue");
            var checkavailable = $(this).attr("data-avalilability");
            var p_price = $(this).attr("data-price");
            var p_compare_price = $(this).attr("data-compareprice");
            if (
              typeof p_compare_price != "undefined" &&
              p_compare_price != ""
            ) {
              $(".price:not(.cust_make_it_price) .price-item--regular").text(
                p_compare_price
              );
              $(".price:not(.cust_make_it_price) .price-item--sale").text(
                p_price
              );
              $(".newpricecustomgs").show();
              $(".without_sale_price").hide();
            } else {
              $(".newpricecustomgs").hide();
              $(".without_sale_price").show();
              $(".without_sale_price").addClass("itsworkingg");

              $(".without_sale_price").addClass("elsecond");
              $(".price:not(.cust_make_it_price) .price-item--regular").text(
                p_price
              );
              $(".price__badge-sale").hide();
            }
            if (checkavailable == "true" || checkavailable == true) {
              setTimeout(function () {
                $(".customcartbtn").attr("data-id", fetchid);
                $(".customcartbtn").text("ADD TO CART");
                $(".customcartbtn .custom-atc").attr("id", "");
                $(".customcartbtn").attr("type", "submit");
                $(".customcartbtn").removeAttr("disabled", "disabled");
              }, 500);
            } else {
              setTimeout(function () {
                $(".customcartbtn").attr("data-id", fetchid);
                $(".customcartbtn .custom-atc").attr("id", "BIS_trigger");
                $(".customcartbtn").attr("type", "button");
                $(".customcartbtn").text("Join the Waitlist");
                $(".customcartbtn").removeAttr("disabled", "disabled");
              }, 500);
            }
          }
        });
      }
    });
    // $(".apple_watch_product .color-swatch").each(function(){
    //   var dd_color= $(this).attr('data-color');
    //   var dd_val= $(this).attr('data-value');
    //   var full_var = size_select_watch+' / ' +dd_color;
    //   $(".ctm_product_form_variants option").each(function(){
    //     var p_price = $(this).attr('data-price');
    //     var p_compare_price = $(this).attr('data-compareprice');

    //     if($(this).text().trim() == full_var){

    //      if(typeof(p_compare_price) != 'undefined' && p_compare_price != '')
    //      {
    //        $(".price:not(.cust_make_it_price) .price-item--regular").text(p_compare_price);
    //        $(".price:not(.cust_make_it_price) .price-item--sale").text(p_price);
    //        $(".price__badge-sale").show();
    //        $(".without_sale_price").hide();
    //        $(".newpricecustomgs").show();
    //      }
    //      else {
    //        $(".without_sale_price").show();
    //        $(".newpricecustomgs").hide();

    //        $(".price:not(.cust_make_it_price) .price-item--regular").text(p_price);
    //        $(".price__badge-sale").hide();
    //      }

    //       var checkavailable = $(this).attr('data-avalilability');
    //       if(checkavailable == "true" || checkavailable == true){
    //         $('.color-swatch[data-value='+dd_val+']').removeAttr("data-stock-status", "out_of_stock");
    //       }
    //       else{
    //         $('.color-swatch[data-value='+dd_val+']').attr("data-stock-status", "out_of_stock");
    //       }
    //     }
    //   });

    // });

    // console.log('selectdro', selectdro);
    // $(".ctm_product_form_variants option").each(function(){

    // var checktagoption1 =$(this).attr('data-colormatch');
    // var checktagoption2 =$(this).attr('data-colormatch1');

    // // console.log($(this).text().trim());
    // if($(this).text().trim() == selectdro){
    //   var fetchid = $(this).attr('data-idvalue');
    //   var checkavailable = $(this).attr('data-avalilability');
    //   if(checkavailable == "true" || checkavailable == true){
    //     setTimeout(function(){

    //         $('.customcartbtn').attr('data-id',fetchid);
    //         // $('.customcartbtn').addClass("teted");
    //         $('.customcartbtn').text("ADD TO CART");
    //         $('.customcartbtn').attr('id', '');
    //         $('.customcartbtn').attr('type', 'submit');
    //         $(".customcartbtn").removeAttr("disabled", "disabled");
    //     },1100);
    //   }
    //   else{
    //      setTimeout(function(){
    //           $('.customcartbtn').attr('data-id',fetchid);
    //           $('.customcartbtn').attr('id','BIS_trigger');
    //           $('.customcartbtn').attr('type','button');
    //           $('.customcartbtn').text("Join the Wishlist");
    //           $(".customcartbtn").removeAttr("disabled", "disabled");
    //        },1100);
    //   }
    // }
    // });
  });
  // $(".apple_watch_product .color-swatch").click(function(){

  // $(".newbadge_discount").addClass('hide');
  // var select_size_app_wat = $('.product-sizes-watch').val();
  // var selectdro2 = select_size_app_wat+'&' +$(this).attr('data-color');
  // var splitchar = selectdro2.split('&');
  // var splittag1 = splitchar[0];
  // var splittag2 = splitchar[1];
  //   $(".newbadge_discount[data-colormatch='"+splittag1+"'][data-colormatch1='"+splittag2+"']").removeClass('hide');

  //   if(select_size_app_wat != "" || typeof(select_size_app_wat) != 'undefined'){
  //     var selectdro = select_size_app_wat+' / ' +$(this).attr('data-color');
  //    // console.log(selectdro);
  //   let allSpam = document.querySelectorAll(".product-tag-list .newbadge_discount");
  //   allSpam.forEach(ele => {
  //     if(select_size_app_wat == ele.getAttribute('data-option1') && $(this).attr('data-color') == ele.getAttribute('data-option2')){
  //       ele.classList.remove("hide");
  //     }else{

  //       if(!ele.classList.contains('hide')){
  //         ele.classList.add("hide");
  //       }
  //     }
  //   });

  //     $(".ctm_product_form_variants option").each(function(){
  //     if($(this).text().trim() == selectdro){
  //       var fetchid = $(this).attr('data-idvalue');
  //       var checkavailable = $(this).attr('data-avalilability');
  //       if(checkavailable == "true" || checkavailable == true){
  //         setTimeout(function(){
  //             $('.customcartbtn').attr('data-id',fetchid)
  //             $('.customcartbtn').text("ADD TO CART");
  //             $('.customcartbtn').attr('id', '');
  //             $('.customcartbtn').attr('type', 'submit');
  //             $(".customcartbtn").removeAttr("disabled", "disabled");
  //         },500);
  //       }
  //       else{
  //          setTimeout(function(){
  //               $('.customcartbtn').attr('data-id',fetchid)
  //               $('.customcartbtn').attr('id','BIS_trigger');
  //               $('.customcartbtn').attr('type','button');
  //               $('.customcartbtn').text("Join the Wishlist");
  //               $(".customcartbtn").removeAttr("disabled", "disabled");
  //            },500);
  //       }
  //     }
  //     });

  //   }
  // });
});
$(document).ready(function () {
  //   $(".color-swatch").each(function(){
  //   var checkprodauantity = $(this).attr('data-available');
  //   if(checkprodauantity == "false" || checkprodauantity == false){
  //     $('#BIS_trigger').text("Join the Waitlist");
  //     $('#BIS_trigger').html("Join the Waitlist");
  //     $('.product-form__submit').addClass('customcartbtn');
  //   }
  //     else{
  //       $('.product-form__submit').addClass('customcartbtn');
  //     }
  // });
  $(".custom_checkout_btn").on("click", function () {
    $(this).addClass("hide");
    $(".checkout-loading").removeClass("hide");
  });
});

// Show the first tab and hide the rest
$(".list-inline-color li:first-child").addClass("active");
$(".tab-content").hide();
$(".tab-content:first").show();

// Click function
$(".list-inline-color").click(function () {
  $(".list-inline-color").removeClass("active");
  $(this).addClass("active");
  $(".tab-content").hide();

  var activeTab = $(this).find("a").attr("href");
  $(activeTab).fadeIn();
  return false;
});

// similar products hover js
// $(document).on("mouseenter",".similar_productcollection  .color-option span",function(e){
// $(this).parents('.card-wrapper').find('.newbadge_discount').addClass('hide');
//       var click_color = $(this).attr("data-color");
//       let discountbadge = $(this).attr('data-value');
//       $(this).parents('.card-wrapper').find('.newbadge_discount[data-colormatch="'+discountbadge+'"]').removeClass('hide');
//       var p_price = $(this).attr('data-price');
//       var p_compare_price = $(this).attr('data-compareprice');
//       var p_badges = $(this).attr('data-badges');
//       var swatchclr = $(this).attr('data-color');
//       if(swatchclr == "Graphite Grey"){
//       $(this).parents('.card-wrapper').find('.customdiscounttags').addClass("hidediscount");
//       }
//       else{
//       $(this).parents('.card-wrapper').find('.customdiscounttags').removeClass("hidediscount");
//       }
//      if(typeof(p_compare_price) != 'undefined' && p_compare_price != '')
//      {
//      $(this).parents('.card-wrapper').find(".similar_productcollection .without_sale_price").text(p_compare_price);
//      $(this).parents('.card-wrapper').find(".similar_productcollection .price-item--sale").text(p_price);
//      $(this).parents('.card-wrapper').find(".similar_productcollection .newpricecustomgs").show();
//      $(this).parents('.card-wrapper').find(".similar_productcollection .without_s_price").hide();
//      $(this).parents('.card-wrapper').find(".similar_productcollection .with_s_price").show();
//      }
//      else {
//        $(this).parents('.card-wrapper').find(".similar_productcollection .newpricecustomgs").hide();
//        $(this).parents('.card-wrapper').find(".similar_productcollection .price-item--regular").text(p_price);
//        $(this).parents('.card-wrapper').find(".similar_productcollection .without_s_price").show();
//        $(this).parents('.card-wrapper').find(".similar_productcollection .with_s_price").hide();
//      }
//     let colorClicked  = $(this).attr('class');
//     let dataPersonlise  = $(this).attr('data-personalize');
//     let vid  = $(this).attr('id');
//     let vurl = $(this).attr('v-url');
//     var colorofyear = $(this).attr('data-color');
//     var color_of_year_main = $("#color_of_year_main").val();
//     if( colorofyear == color_of_year_main){
//     $(this).parents('.card-wrapper').find('.colorofyear').removeClass('hide');
//     }
//     else{
//     $(this).parents('.card-wrapper').find('.colorofyear').addClass('hide');
//     }
//     // check new custom tags

//      var checkcusattr1 = $(this).attr('data-tag1');
//      var checkcusattrvalue1 = $(this).attr('data-tagvalue1');
//      var checkcusattr2 = $(this).attr('data-tag2');
//      var checkcusattrvalue2 = $(this).attr('data-tagvalue2');
//      var checkcusattr3 = $(this).attr('data-tag3');
//      var checkcusattrvalue3 = $(this).attr('data-tagvalue3');

//      if(checkcusattr1 == 'true' || checkcusattr1 == true)
//      {
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag1').removeClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag1').text(checkcusattrvalue1);
//      }else{
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag1').addClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag1').text('');
//      }

//      if(checkcusattr2 == 'true' || checkcusattr2 == true)
//      {

//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag2').removeClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag2').text(checkcusattrvalue2);
//      }else{
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag2').addClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag2').text('');
//      }

//      if(checkcusattr3 == 'true' || checkcusattr3 == true)
//      {
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag3').removeClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag3').text(checkcusattrvalue3);
//      }else{
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag3').addClass('hide');
//        $(this).parents('.card-wrapper').find('.card__badge .custtomtag3').text('');
//      }

//   // ends
//     var url = $('.card--product a').attr('href')
//     $(this).parents('.card-wrapper').find('.card-information__wrapper a').attr('href',vurl);
//     $(this).parents('.card-wrapper').find('.card--product a').attr('href',vurl);

//     if(dataPersonlise == "true" || dataPersonlise == true)
//     {
//       $(this).parents('.card-wrapper').find('.engrave').addClass('nomonogramshows');
//     }
//     else
//     {
//       $(this).parents('.card-wrapper').find('.engrave').removeClass('nomonogramshows');
//     }

//     $('img[img-id="'+vid+'"]').addClass('hide');
//     $('img[img-id="'+vid+'"][img-text~="'+colorClicked+'"]').removeClass('hide');
//     $('.image-2-flip .product_image_list_2').addClass('hide');
//     $('.image-2-flip .product_image_list_2[data-alt="'+colorClicked+' flip"]').removeClass('hide');

// });

$(document).ready(function () {
  $(".onhovereffect").mouseenter(function () {
    $(this).parents(".customhome-collection").addClass("hoverSecondImage");
  });
  $(".onhovereffect").mouseleave(function () {
    if ($(this).parents(".customhome-collection").hasClass("hoverSecondImage"))
      $(this).parents(".customhome-collection").removeClass("hoverSecondImage");
  });
  $(".color-swatch").click(function () {
    var Varinatctamessage = $(this).attr("data-vctamessage");
    var prodefaultctamessage = $("#prodefaultctamessage").attr(
      "data-prodefaultctamessage"
    );
    var defaultctamessage = $("#defaultctamessage").attr(
      "data-defaultctamessage"
    );

    console.log(Varinatctamessage);
    if (Varinatctamessage != "") {
      $(".product-benefits p").text(Varinatctamessage);
    } else if (Varinatctamessage == "" && prodefaultctamessage != "") {
      $(".product-benefits p").text(prodefaultctamessage);
    } else {
      $(".product-benefits p").text(defaultctamessage);
    }

    var urlvarid = $(this).attr("data-clrid");
    console.log(urlvarid);
    // if($(this).attr('data-status') == "checkedx"){
    // var origin=window.location.origin;
    // var pathname=window.location.pathname;
    // console.log(window.location.origin);
    // window.history.pushState({}, '', origin+pathname+'?variant='+urlvarid);
    //   console.log(window.history.pushState);
    // }
    $("body")
      .find(
        '.similar_products .price-item--last:contains("AUD"), .similar_products .with_sale_price:contains("AUD"), .newregularprice:contains("AUD")'
      )
      .each(function () {
        $(this).html($(this).html().split("AUD").join(""));
      });
    var checkmonogramtext = $(this).attr("data-personalize");
    if (checkmonogramtext == true || checkmonogramtext == "true") {
      $(this)
        .parents(".customproduct_wrap")
        .find(".engrave-s-product")
        .addClass("nomonogramshows");
    } else {
      $(this)
        .parents(".customproduct_wrap")
        .find(".engrave-s-product")
        .removeClass("nomonogramshows");
    }
  });
});

// get time between two dates
// const date1 = new Date();
// const date2 = new Date('12/18/2023');
// const diffTime = Math.abs(date2 - date1);

// console.log(diffTime + " milliseconds");
// console.log(diffDays + " days");
// console.log(date1);

function dateDiffInDays(a, b) {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

// test it
const a = new Date(),
  b = new Date("2023-03-19"),
  difference = dateDiffInDays(a, b);

$(document).ready(function () {
  $(".viewbtn2").hide();
  $(".viewbtn3").hide();
  $(".viewbtn4").hide();
  $(".viewbtn5").hide();
  $(".viewbtn6").hide();
  $(".viewbtn7").hide();
  $(".viewbtn8").hide();
  $(".viewbtn9").hide();
});
$(".tab-index").click(function () {
  var clrwheel = $(this).attr("data-clr");
  if (clrwheel == "black-caviar") {
    $(".viewbtn1").show();
    $(".viewbtn2").hide();
    $(".viewbtn3").hide();
    $(".viewbtn4").hide();
    $(".viewbtn5").hide();
    $(".viewbtn6").hide();
    $(".viewbtn7").hide();
    $(".viewbtn8").hide();
    $(".viewbtn9").hide();
  }
  if (clrwheel == "lapis-blue") {
    $(".viewbtn2").show();
    $(".viewbtn1").hide();
    $(".viewbtn3").hide();
    $(".viewbtn4").hide();
    $(".viewbtn5").hide();
    $(".viewbtn6").hide();
    $(".viewbtn7").hide();
    $(".viewbtn8").hide();
    $(".viewbtn9").hide();
  }
  if (clrwheel == "emerald-green") {
    $(".viewbtn2").hide();
    $(".viewbtn1").hide();
    $(".viewbtn3").show();
    $(".viewbtn4").hide();
    $(".viewbtn5").hide();
    $(".viewbtn6").hide();
    $(".viewbtn7").hide();
    $(".viewbtn8").hide();
    $(".viewbtn9").hide();
  }
  if (clrwheel == "pomegranate-red") {
    $(".viewbtn2").hide();
    $(".viewbtn1").hide();
    $(".viewbtn3").hide();
    $(".viewbtn4").show();
    $(".viewbtn5").hide();
    $(".viewbtn6").hide();
    $(".viewbtn7").hide();
    $(".viewbtn8").hide();
    $(".viewbtn9").hide();
  }
  if (clrwheel == "pink-lily") {
    $(".viewbtn2").hide();
    $(".viewbtn1").hide();
    $(".viewbtn3").hide();
    $(".viewbtn4").hide();
    $(".viewbtn5").show();
    $(".viewbtn6").hide();
    $(".viewbtn7").hide();
    $(".viewbtn8").hide();
    $(".viewbtn9").hide();
  }
  if (clrwheel == "pink-lily") {
    $(".viewbtn2").hide();
    $(".viewbtn1").hide();
    $(".viewbtn3").hide();
    $(".viewbtn4").hide();
    $(".viewbtn5").show();
    $(".viewbtn6").hide();
    $(".viewbtn7").hide();
    $(".viewbtn8").hide();
    $(".viewbtn9").hide();
  }
  if (clrwheel == "saharan-nude") {
    $(".viewbtn2").hide();
    $(".viewbtn1").hide();
    $(".viewbtn3").hide();
    $(".viewbtn4").hide();
    $(".viewbtn5").hide();
    $(".viewbtn6").show();
    $(".viewbtn7").hide();
    $(".viewbtn8").hide();
    $(".viewbtn9").hide();
  }
  if (clrwheel == "bondi-blue") {
    $(".viewbtn2").hide();
    $(".viewbtn1").hide();
    $(".viewbtn3").hide();
    $(".viewbtn4").hide();
    $(".viewbtn5").hide();
    $(".viewbtn6").hide();
    $(".viewbtn7").show();
    $(".viewbtn8").hide();
    $(".viewbtn9").hide();
  }
  if (clrwheel == "manhattan-orange") {
    $(".viewbtn2").hide();
    $(".viewbtn1").hide();
    $(".viewbtn3").hide();
    $(".viewbtn4").hide();
    $(".viewbtn5").hide();
    $(".viewbtn6").hide();
    $(".viewbtn7").hide();
    $(".viewbtn8").show();
    $(".viewbtn9").hide();
  }
  if (clrwheel == "shibuya-fuchsia") {
    $(".viewbtn2").hide();
    $(".viewbtn1").hide();
    $(".viewbtn3").hide();
    $(".viewbtn4").hide();
    $(".viewbtn5").hide();
    $(".viewbtn6").hide();
    $(".viewbtn7").hide();
    $(".viewbtn8").hide();
    $(".viewbtn9").show();
  }
});

$(document).ready(function () {
  $(".product-sizes-watch").change(function () {
    var selected_size_value = $(this).val();
    var selected_color_value = "";
    $(".color-swatch").each(function () {
      if ($(this).attr("data-status") == "checkedx") {
        selected_color_value = $(this).attr("data-value");
      }
    });
    $("#custom_option_hide span").each(function () {
      if (
        $(this).attr("data-title2") == selected_size_value &&
        $(this).attr("data-title") == selected_color_value
      ) {
        var selected_variant_id = $(this).attr("data-value");
        $(".product-form__buttons .cart_add_btn").attr(
          "data-id",
          selected_variant_id
        );
      }
    });
  });
  $("#size_product").change(function () {
    window.location = $(this).val();
  });
});

// customer address js
// slider js starts
function pysslidenext() {
  const element = document.querySelector(".product__media-list");
  element.scrollLeft = element.scrollLeft + 400;
}
if(document
  .querySelector(".slider-button--next")){
document
  .querySelector(".slider-button--next")
  .addEventListener("click", function () {
    pysslidenext();
  });
}
function pysslideprev() {
  const element = document.querySelector(".product__media-list");
  element.scrollLeft = element.scrollLeft - 400;
}
if(document
  .querySelector(".slider-button--prev")){
document
  .querySelector(".slider-button--prev")
  .addEventListener("click", function () {
    pysslideprev();
  });
}
// ends

$(document).ready(function () {
  $(".initials_field input").keyup(function () {
    var matchval = $(this).val();
    if (matchval == "MM" || matchval == "WW") {
      $(".engrave-customizer").addClass("textmw");
      $(".engrave-s-product").addClass("textmw");
    } else {
      $(".engrave-customizer").removeClass("textmw");
      $(".engrave-s-product").removeClass("textmw");
    }
  });
});

// Class add according to the browser

var bodyElement = document.body;
// Check if the user is using Safari
if (
  navigator.userAgent.indexOf("Safari") != -1 &&
  navigator.userAgent.indexOf("Chrome") == -1
) {
  // Add a class for Safari
  bodyElement.classList.add("safaribrowser");
}
// ends
